import React, {useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  IconButton,
  Paper,
  TablePagination,
  Tooltip,
  Grid,
  TextField
} from "@material-ui/core";
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import UserManagementPageApis from "../services/UserManagementPageServices";
import NoDataFound from "../../../common-components/no-data-found/NoDataFound";
import CommonUtils from "../../../services/utils";
import UserManagementPageDataSetter from "../services/UserManagementPageUtils";
import AssignGrandparentAccDialogBox from "../components/AssignGrandparentAccountDialogBox";
import AssignUserRoleDialogBox from "../components/AssignUserRoleDialogBox";
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteUserAccount from "../components/DeleteUserAccountDialogBox";

const useStyles = makeStyles((theme) => ({
  root: {
    height: window.innerHeight,
    // backgroundImage: "url('/path/to/background-image.jpg')",
    width: '100%',
  },
  card: {
    width: '94%',
    marginLeft: '3%',
    marginTop: '1%',
    backgroundColor: 'whitesmoke',
  },
  header: {
    backgroundColor: '#0055a4',
  },
  headerText: {
    fontSize: 23,
    paddingBottom: 5,
    color: 'white',
  },
  logo: {
    width: '5%',
    paddingTop: 20,
    paddingLeft: 15,
    paddingBottom: 0,
    paddingRight: 5,
  },
  table: {
    minWidth: 650,
    overflow:'auto'
  },
  tableHeaderCell: {
    padding: '4px 8px', // Reduced padding for header cells
    fontSize: '0.875rem', // Smaller font size for header cells
    fontWeight: 'bold', // Bold font for header cells
  },
  tableCell: {
    padding: '4px 8px',
  },
  button: {
    margin: theme.spacing(0.5),
    padding: theme.spacing(0.5),
  },
  disabledButton: {
    color:'lightgrey',
  }
}));

// USED FOR SORTING
function descendingComparator(a, b, orderBy) {
  if (typeof a[orderBy] === 'string' && typeof b[orderBy] === 'string') {
     let firstVal = a[orderBy].toLowerCase().trim()
     let secondVal = b[orderBy].toLowerCase().trim()
     if (secondVal < firstVal) {
       return -1;
     }
     if (secondVal > firstVal) {
       return 1;
     }
     return 0;

   } else {
    let firstVal = a[orderBy]
    let secondVal = b[orderBy]
    if (secondVal < firstVal) {
      return -1;
    }
    if (secondVal > firstVal) {
      return 1;
    }
    return 0;
  }
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function AdminUserTable() {
  const classes = useStyles();
  const userManagementPageApi = new UserManagementPageApis();
  const commonUtils = new CommonUtils();
  const userManagementPageDataSetter = new UserManagementPageDataSetter();
  const [userList, setUserList] = useState([]);
  const [originalUserList, setOriginalUserList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("LocationName");
  const [arrRowsPerPageOptions, setArrRowsPerPageOptions] = useState([]);
  const [isGPAccDialogBoxOpen, setGPAccDialogBox] = useState(false);
  const [isUserRoleDialogBoxOpen, setUserRoleDialogBox] = useState(false);
  const [isDeleteUserDialogBoxOpen, setDeleteUserDialogBox] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [searchUserValue, setSearchUserValue] = useState("");
  useEffect(() => {
    userManagementPageApi.getUserList().then((response) => {
      if (response.model.length > 0)
      setOriginalUserList(response.model)
      setUserList(response.model)
    })  

    let arr = commonUtils.rowPerPageSelector(userList.length);
    setArrRowsPerPageOptions(arr);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]) 


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };


  const handleAssignGPAccDialogBoxOpen = (userInfo) => {
    setSelectedUser(userInfo);
    setGPAccDialogBox(true);
  };

  const handleAssignGPAccDialogBoxClose = () => {
    setGPAccDialogBox(false);
  };

  const handleAssignUserRoleDialogBoxOpen = (userInfo) => {
    setSelectedUser(userInfo);
    setUserRoleDialogBox(true);
  };

  const handleAssignUserRoleDialogBoxClose = () => {
    setUserRoleDialogBox(false);
  };

  const handleDeleteUserAccountDialogBoxOpen = (userInfo) => {
    setSelectedUser(userInfo);
    setDeleteUserDialogBox(true);
  };

  const handleDeleteUserAccountDialogBoxClose = () => {
    setDeleteUserDialogBox(false);
  };

    // USED FOR SEARCHING THE TABLES
    const searchTableData = (event) => {
      setSearchUserValue(event.target.value);
      let searchText = event.target.value.toLowerCase();
      let filteredData = userManagementPageDataSetter.searchUser(originalUserList, searchText);
      setUserList(filteredData);
    };
  return (
    <div>
              <TableContainer>
                <Paper className={classes.card}>
                <Grid item sm={12} style={{marginTop:15,  marginBottom:10}}>
              <TextField
              margin="dense"
              name="searchUserInfo"
              label="Search User"
              type="text"
              value={searchUserValue}
              onChange={searchTableData}
              className={classes.formField}
              variant="outlined"
              style={{marginRight:40}}
            />

            </Grid>
                <Table className={classes.table} aria-label="simple table" size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeaderCell}>User ID</TableCell>
                    <TableCell className={classes.tableHeaderCell}>User Role</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Grand Parent Acct</TableCell>
                    <TableCell className={classes.tableHeaderCell}>First Name</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Middle Name</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Last Name</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Email Add</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Country Code</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Phone Number</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Updated Date</TableCell>
                    <TableCell className={classes.tableHeaderCell}>Delete User</TableCell>
                  </TableRow>
                </TableHead>
                {userList.length > 0 && (
                <TableBody>
                  {stableSort(
                    userList,
                    getComparator(order, orderBy)
                  )
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      return (
                        <TableRow key={row.userId} size="small">
                        <TableCell className={classes.tableCell}>{row.userId}</TableCell>
                        <TableCell className={classes.tableCell}>
                          <Tooltip title="Change Role">
                            <Button color="primary" onClick={() => handleAssignUserRoleDialogBoxOpen(row)}>{row.userRole}</Button>
                          </Tooltip>
                        </TableCell>
                        <TableCell className={classes.tableCell}>{row.grandParentAccountId ? row.grandParentAccountId : 
                              <Tooltip title='add grandparent account'>
                                <IconButton style={{marginLeft:20}} onClick={() =>  handleAssignGPAccDialogBoxOpen(row)} >
                                  <PersonAddIcon style={{color:'#0055A4'}}/>
                                </IconButton>
                              </Tooltip>
                              }
                        </TableCell>
                        {/* <TableCell className={classes.tableCell}>{row.userRole}</TableCell> */}
                        {/* <TableCell className={classes.tableCell}>{row.grandParentAccountId}</TableCell> */}
                        <TableCell className={classes.tableCell}>{row.firstName}</TableCell>
                        <TableCell className={classes.tableCell}>{row.middleName}</TableCell>
                        <TableCell className={classes.tableCell}>{row.lastName}</TableCell>
                        <TableCell className={classes.tableCell}>{row.emailAddress}</TableCell>
                        <TableCell className={classes.tableCell}>{row.countryCode}</TableCell>
                        <TableCell className={classes.tableCell}>{row.phoneNumber}</TableCell>
                        <TableCell className={classes.tableCell}>{row.updatedDate ? commonUtils.formatISODate(row.updatedDate) : ""}</TableCell>
                        <TableCell className={classes.tableCell}>
                          <IconButton style={{marginLeft:20}} onClick={() => handleDeleteUserAccountDialogBoxOpen(row)} >
                            <DeleteIcon style={{color:'#0055A4'}}/>
                          </IconButton>
                        </TableCell>
                    </TableRow>
                      );
                    })}
                </TableBody>
              )}
              </Table>
              {userList.length === 0 && (
                <TableBody>
                  <TableRow>
                    <TableCell
                      className="no-match-found"
                      colSpan={8}
                      align="center"
                    >
                      <div className="no-data-container">
                        <NoDataFound noDataType="table"></NoDataFound>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
                </Paper>
              </TableContainer>
              <TablePagination
            rowsPerPageOptions={arrRowsPerPageOptions}
            component="div"
            count={userList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            SelectProps={{
              inputProps: {
                'aria-label': 'rows per page',
              },
              native: true,
            }}
          />
            <AssignGrandparentAccDialogBox
            open={isGPAccDialogBoxOpen}
            onClose={handleAssignGPAccDialogBoxClose}
            selectedUser={selectedUser}
            />
            <AssignUserRoleDialogBox
            open={isUserRoleDialogBoxOpen}
            onClose={handleAssignUserRoleDialogBoxClose}
            selectedUser={selectedUser}
            />
            <DeleteUserAccount
            open={isDeleteUserDialogBoxOpen}
            onClose={handleDeleteUserAccountDialogBoxClose}
            selectedUser={selectedUser}
            />
    </div>
  );
}

export default AdminUserTable;